export default __webpack_public_path__ + "static/bkrm-logo-my-3f574cf445c044bd7052f3357199f7dd.png";